export default __webpack_public_path__ + "static/6867-ecc285b3baf3dd3ae10ee778ef5006a3.jpg";